<template>
  <!-- content start -->
  <div
    :style="{
      backgroundImage: `url(${mainBackgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }"
  >
    <div class="layout-wrapper" style="width: 100%; height: 90vh;">
      <!-- -------------------- FIXED HEADER -------------------- -->
      <div class="fixed-header" style="">
        <div
          style="display: flex; justify-content: center; align-items: center; gap: 20px;"
        >
          <h3
            style="color: #000000;margin: 0px; font-weight: bold; font-size: 16px;"
          >
            Survey
          </h3>
        </div>
        <div>
          <img
            v-on:click="handleBack()"
            src="@/assets/Close-1.png"
            style="width: 22px; height: 22px; cursor: pointer;"
            alt=""
          />
        </div>
      </div>

      <!-- Progress Bar -->
      <div v-if="!game_data.already_responed" style="padding: 0px 13px;">
        <div style="width: 100%; height: 2px; background-color: gray;">
          <div
            :style="{
              height: '2px',
              backgroundColor: 'black',
              width: progress + '%',
              transition: 'all 0.5s ease'
            }"
          ></div>
        </div>
      </div>

      <!-- Main Content Area -->
      <div
        class="scroll-area"
        v-if="game_data.already_responed"
        :style="{
          justifyContent: game_data.already_responed ? 'start' : 'space-evenly'
        }"
      >
        <!-- Thank You Screen -->
        <div
          v-if="game_data.score_screen === 'thank_you'"
          style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 80vh;"
        >
          <div
            class="card"
            :style="{
              padding: '30px',
              backgroundImage: `url(${asset('flyy_score_screen_bck1.png')})`,
              backgroundSize: 'cover',
              backgroundPosition: 'top center',
              backgroundRepeat: 'no-repeat',
              boxShadow:
                'rgba(50,50,93,0.25) 0px 13px 27px -5px, rgba(0,0,0,0.3) 0px 8px 16px -8px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              maxWidth: '400px'
            }"
          >
            <div class="card-icon">
              <img
                src="@/assets/thank-you.png"
                alt="thank-you"
                style="width: 80%; height: auto;"
              />
            </div>

            <div style="text-align: center; width: 100%; overflow: hidden;">
              <p
                class="thank-text"
                :style="{
                  color: isTitleColour
                }"
              >
                {{ isTitle ? isTitle : "Thank You" }}!
              </p>

              <p
                class="thank-des"
                :style="{
                  color: isTitleColour
                }"
              >
                {{
                  isDescription
                    ? isDescription
                    : "You are wise in your financial decisions."
                }}
              </p>
            </div>
          </div>

          <!-- Share & Deeplink Button -->
          <div
            class="deeplink-btn-div"
            :style="{
              justifyContent: showOnlyOneButton ? 'center' : 'space-between',
              'box-sizing': 'border-box'
            }"
          >
            <button
              class="deeplink-btn"
              v-if="
                game_data.enable_share_link &&
                  game_data.share_link_button_text !== ''
              "
              @click="handleShareClick"
              :style="{
                backgroundColor: isButtonColour || '#c7222a',
                color: isButtonTextColour || '#ffffff',
                width: showOnlyOneButton ? '50%' : '50%'
              }"
            >
              {{
                game_data.share_link_button_text.length > 12
                  ? game_data.share_link_button_text.substring(0, 12) + ".."
                  : game_data.share_link_button_text
              }}
            </button>

            <button
              class="deeplink-btn"
              v-if="game_data.enable_deeplink && game_data.deeplink_button_text"
              @click="handleDeeplinkClick"
              :style="{
                backgroundColor: isButtonColour || '#c7222a',
                color: isButtonTextColour || '#ffffff',
                width: showOnlyOneButton ? '50%' : '50%'
              }"
            >
              {{
                game_data.deeplink_button_text.length > 12
                  ? game_data.deeplink_button_text.substring(0, 12) + ".."
                  : game_data.deeplink_button_text
              }}
            </button>
          </div>
        </div>

        <!-- Score Screen -->
        <div
          v-else-if="
            game_data.user_data ||
              (game_data.additional_data &&
                game_data.additional_data.length > 0)
          "
          style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; gap: 20px;"
        >
          <!-- Single Item (Only user_data) -->
          <div
            v-if="game_data.user_data && filteredAdditionalData.length === 0"
            class="score-main-div"
          >
            <div v-if="!isScoreDataReady"></div>

            <div
              v-else
              class="user-card"
              style="width: 90%; border-radius: 15px; padding: 30px; background-color: #ffffff; box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0 auto;"
            >
              <div
                style="width: 120px; height: 120px; position: absolute; top: -60px;"
              >
                <img
                  v-if="game_data.user_data.image_url"
                  :src="game_data.user_data.image_url"
                  alt="score"
                  style="width: 100%; height: 100%; object-fit: contain; border-radius: 10px;"
                />
              </div>

              <div style="padding-top: 80px; text-align: center;">
                <p style="margin: 0; font-size: 16px; font-weight: 600;">
                  Hi {{ userName }}
                </p>
                <p style="margin: 8px 0; font-size: 15px; font-weight: bold;">
                  {{ game_data.user_data.title }}
                </p>
                <p style="margin: 0; font-size: 13px; line-height: 1.4;">
                  {{ game_data.user_data.description }}
                </p>
              </div>
            </div>
          </div>

          <!-- Multiple Items -->
          <div v-else-if="game_data.user_data" class="score-main-div">
            <div
              class="score-main"
              :style="{
                backgroundImage: `url(${asset('flyy_score_screen_bck1.png')})`,
                boxShadow:
                  'rgba(50,50,93,0.25) 0px 13px 27px -5px, rgba(0,0,0,0.3) 0px 8px 16px -8px'
              }"
            >
              <div class="score-logo">
                <img
                  v-if="game_data.user_data.image_url"
                  :src="game_data.user_data.image_url"
                  alt="score"
                  style="width: 100%; height: 100%; object-fit: contain;"
                />
              </div>

              <div class="score-heading-div">
                <p class="score-heading">Hi {{ userName }}</p>
                <p class="score-sub-heading">{{ game_data.user_data.title }}</p>
                <p class="score-des">{{ game_data.user_data.description }}</p>
              </div>
            </div>

            <!-- ADDITIONAL DATA CARDS -->
            <div
              style="-webkit-overflow-scrolling: touch;"
              class="additional-data-div"
            >
              <div
                v-for="(item, index) in filteredAdditionalData"
                :key="index"
                class="moderate-div"
              >
                <img
                  v-if="item.image_url"
                  :src="item.image_url"
                  alt="score"
                  class="img-moderate"
                />
                <p class="moderate-text">{{ item.title }}</p>
              </div>
            </div>

            <!-- BUTTONS -->
            <div
              class="btn-score-div"
              :style="{
                justifyContent: showOnlyOneButton ? 'center' : 'space-between',
                // width: game_data.additional_data.length === 1 ? '300px' : '86%'
                // gap: '5px',
                marginTop: '10px'
              }"
            >
              <button
                v-if="
                  game_data.enable_share_link &&
                    game_data.share_link_button_text !== ''
                "
                @click="handleShareClick"
                :style="{
                  border: 'none',
                  backgroundColor: isButtonColour || '#c7222a',
                  color: isButtonTextColour || '#ffffff',
                  padding: '14px 10px',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  width: showOnlyOneButton ? '50%' : '50%',
                  fontSize: '14px'
                }"
              >
                {{
                  game_data.share_link_button_text.length > 12
                    ? game_data.share_link_button_text.substring(0, 12) + ".."
                    : game_data.share_link_button_text
                }}
              </button>

              <button
                v-if="
                  game_data.enable_deeplink && game_data.deeplink_button_text
                "
                @click="handleDeeplinkClick"
                :style="{
                  border: 'none',
                  backgroundColor: isButtonColour || '#c7222a',
                  color: isButtonTextColour || '#ffffff',
                  padding: '14px 10px',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  width: showOnlyOneButton ? '50%' : '50%',
                  fontSize: '14px'
                }"
              >
                {{
                  game_data.deeplink_button_text.length > 12
                    ? game_data.deeplink_button_text.substring(0, 12) + ".."
                    : game_data.deeplink_button_text
                }}
              </button>
            </div>
          </div>
        </div>

        <!-- Fallback if additional_data is not available -->
        <div
          v-else
          style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; gap: 20px;"
        >
          <div style="text-align: center; padding: 20px;">
            <h3>Survey Completed!</h3>
            <p>Thank you for your participation.</p>
            <p v-if="game_data.score !== undefined">
              Your Score: {{ game_data.score }}
            </p>
          </div>

          <div
            :style="{
              justifyContent: showOnlyOneButton ? 'center' : 'space-between'
            }"
            class="btn-score-div"
          >
            <button
              v-if="
                game_data.enable_share_link &&
                  game_data.share_link_button_text !== ''
              "
              @click="handleShareClick"
              :style="{
                border: 'none',
                backgroundColor: isButtonColour || '#c7222a',
                color: isButtonTextColour || '#ffffff',
                padding: '10px 20px',
                borderRadius: '10px',
                cursor: 'pointer',
                width: '50%'
              }"
            >
              {{ game_data.share_link_button_text }}
            </button>

            <button
              v-if="game_data.enable_deeplink && game_data.deeplink_button_text"
              @click="handleDeeplinkClick"
              :style="{
                border: 'none',
                backgroundColor: isButtonColour || '#c7222a',
                color: isButtonTextColour || '#ffffff',
                padding: '10px 20px',
                borderRadius: '10px',
                cursor: 'pointer',
                width: '50%'
              }"
            >
              {{ game_data.deeplink_button_text }}
            </button>
          </div>
        </div>
      </div>

      <!-- Question Display Area -->
      <div
        v-else
        style="display: flex; flex-direction: column; justify-content: center; flex: 1;"
      >
        <div style="padding: 15px;">
          <div>
            <!-- Non-Rating Questions -->
            <div
              :style="{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                padding: '10px',
                borderRadius: '12px',
                maxHeight: '65vh',
                display: 'flex',
                flexDirection: 'column'
                // alignItems:  game_data.ps_questions[questionIndex].question_type !== 'rating'? 'flex-start'
              }"
              v-if="
                game_data.ps_questions[questionIndex].question_type !== 'rating'
              "
            >
              <div style="flex: 1; overflow-y: auto; margin-bottom: 15px;">
                <p
                  :style="{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: isTitleColour,
                    textAlign: 'left'
                    // margin: '10px 5px'
                  }"
                  style="margin: 10px 5px !important;"
                >
                  {{ game_data.ps_questions[questionIndex].title }}
                </p>

                <div>
                  <!-- Text Based Options -->
                  <div
                    v-if="
                      game_data.ps_questions[questionIndex].option_type ===
                        'text'
                    "
                  >
                    <div
                      v-for="(option, index) in game_data.ps_questions[
                        questionIndex
                      ].options"
                      :key="option.id"
                    >
                      <div
                        class="selected-options"
                        :style="{
                          border:
                            selectedOptionId === option.id
                              ? '2px solid' + isSelectedColour
                              : '1px solid #ccc'
                        }"
                        @click="selectOption(option.id)"
                      >
                        <p
                          :style="{
                            margin: 0,
                            fontSize: '12px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            color: isTitleColour,
                            padding: '10px',
                            textAlign: 'left'
                          }"
                        >
                          {{ option.title }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Image Based Options -->
                  <div v-else class="image-box-rating">
                    <div
                      class="image-pic"
                      v-for="(option, index) in game_data.ps_questions[
                        questionIndex
                      ].options"
                      :key="option.id"
                      :style="{
                        backgroundColor: '#ffffff',
                        padding: '12px 10px 10px 10px',
                        borderRadius: '10px',
                        width: '45%',
                        cursor: 'pointer',
                        border:
                          selectedOptionId === option.id
                            ? '2px solid' + isSelectedColour
                            : '1px solid #ccc',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        boxSizing: 'border-box'
                      }"
                      @click="selectOption(option.id)"
                    >
                      <div
                        style="width: 100%; height: 70px; display: flex; justify-content: center; align-items: center;"
                      >
                        <img
                          :src="option.option_image_url"
                          :alt="option.title"
                          @error="event => (event.target.src = fallbackImage)"
                          style="max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 5px;"
                        />
                      </div>
                      <p
                        :style="{
                          color: isTitleColour,
                          fontSize: '12px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          margin: '0',
                          textAlign: 'center'
                        }"
                      >
                        {{ option.title }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Navigation Buttons -->
              <div
                style="margin-top: 0px; display: flex; justify-content: center; align-items: center; gap: 10px"
              >
                <button
                  class="next-btn"
                  v-if="!isLast"
                  :style="{
                    width: '35%',
                    border: 'none',
                    backgroundColor: isPrevious ? isButtonColour : '#FFE7E5',
                    color: isPrevious ? isButtonTextColour : isButtonColour,
                    borderRadius: '60px',
                    cursor: 'pointer',
                    fontSize: '25px'
                  }"
                  v-on:click="handlePreviousQuestion()"
                >
                  &lt;
                </button>

                <button
                  class="next-btn"
                  :disabled="!isSelected && !game_data.already_responed"
                  :style="{
                    width: '35%',
                    border: 'none',
                    backgroundColor: isSelected ? isButtonColour : '#FFE7E5',
                    color: isSelected ? '#ffffff' : isButtonColour,
                    borderRadius: '60px',
                    cursor: 'pointer',
                    fontSize: isLast ? '16px' : '25px'
                  }"
                  @click="handleNextQuestion()"
                >
                  {{ isLast ? "Done" : ">" }}
                </button>
              </div>
            </div>

            <!-- Rating Type Questions -->
            <div
              v-else
              :style="{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                // height: '180px',
                padding: '10px 5px 0px 5px',
                borderRadius: '12px',
                overflowY: 'auto'
              }"
            >
              <div style="margin: 10px; border-radius: 5px; overflow: scroll;">
                <p
                  :style="{
                    margin: 0,
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: isTitleColour,
                    textAlign: 'left'
                  }"
                >
                  {{ game_data.ps_questions[questionIndex].title }}
                </p>

                <div>
                  <!-- Text Based Options for Rating -->
                  <div
                    v-if="
                      game_data.ps_questions[questionIndex].option_type ===
                        'text'
                    "
                  >
                    <div
                      v-for="(option, index) in game_data.ps_questions[
                        questionIndex
                      ].options"
                      :key="option.id"
                    >
                      <div
                        :style="{
                          backgroundColor: '#ffffff',
                          marginTop: '10px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          border:
                            selectedOptionId === option.id
                              ? '2px solid' + isSelectedColour
                              : '1px solid #ccc'
                        }"
                        @click="selectOption(option.id)"
                      >
                        <p
                          :style="{
                            margin: 0,
                            fontSize: '12px',
                            fontWeight: '500',
                            color: isTitleColour,
                            cursor: 'pointer'
                          }"
                        >
                          {{ option.title }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Image Based Options for Rating -->
                  <div
                    v-else
                    ref="optionsWrapper"
                    style="display: flex; gap: 8px; justify-content: center;"
                  >
                    <div
                      v-for="(option, index) in game_data.ps_questions[
                        questionIndex
                      ].options"
                      :key="option.id"
                      :ref="el => (optionRefs[index] = el)"
                      :style="{
                        backgroundColor: '#ffffff',
                        padding: '5px 10px',
                        marginTop: '10px',
                        borderRadius: '5px',
                        width: optionCardWidth + '%',
                        height: '60px',
                        // height: optionCardHeight + 'px',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        boxSizing: 'border-box',
                        opacity: selectedOptionId === option.id ? 1 : 0.4,
                        transition: 'opacity 0.3s ease',
                        filter:
                          selectedOptionId === option.id
                            ? 'none'
                            : 'grayscale(100%)'
                      }"
                      @click="selectOption(option.id, index)"
                    >
                      <div
                        style="width: 100%; height: 60px; display: flex; justify-content: center; align-items: center; overflow: hidden;"
                      >
                        <img
                          :src="option.option_image_url"
                          @error="event => (event.target.src = fallbackImage)"
                          :alt="option.title"
                          :style="{
                            width: '80%',
                            height: '40px',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            borderRadius: '5px',
                            display: 'block',
                            marginBottom: '10px',
                            paddingTop: '8px'
                          }"
                        />
                      </div>
                      <p
                        :style="{
                          color: isTitleColour,
                          fontSize: '9px',
                          fontWeight: '500',
                          textAlign: 'center',
                          margin: '0px',
                          cursor: 'pointer'
                        }"
                      >
                        {{ option.title }}
                      </p>
                    </div>
                  </div>

                  <!-- Styled Progress Slider -->
                  <div
                    style="position: relative; width: 100%; height: 10px; background-color: #ddd; border-radius: 5px; margin-bottom: 10px; margin-top: 15px;"
                  >
                    <div
                      :style="{
                        width: progressPercentage + 'px',
                        height: '100%',
                        backgroundColor: isSeekbarColour,
                        borderRadius: '5px',
                        transition: 'width 0.3s ease-in-out'
                      }"
                    ></div>

                    <div
                      :style="{
                        position: 'absolute',
                        top: '-5px',
                        left: sliderKnobLeft + 'px',
                        width: '14px',
                        height: '14px',
                        backgroundColor: '#ffffff',
                        border: '3px solid' + isSeekbarColour,
                        borderRadius: '50%',
                        transition: 'left 0.3s ease-in-out',
                        boxShadow: '0 0 2px rgba(0,0,0,0.3)'
                      }"
                    ></div>
                  </div>
                </div>

                <!-- Navigation Buttons for Rating -->
                <div
                  style="margin-top: 15px; display: flex; justify-content: center; align-items: center; gap: 10px"
                >
                  <button
                    class="next-btn"
                    v-if="!isLast"
                    :style="{
                      width: '35%',
                      border: 'none',
                      backgroundColor: isPrevious ? isButtonColour : '#FFE7E5',
                      // backgroundColor: isPrevious
                      //   ? isButtonColour
                      //   : isButtonTextColour,
                      borderRadius: '60px',
                      color: isPrevious ? isButtonTextColour : isButtonColour,
                      cursor: 'pointer',
                      fontSize: '25px'
                    }"
                    v-on:click="handlePreviousQuestion()"
                  >
                    &lt;
                  </button>

                  <button
                    class="next-btn"
                    :disabled="!isSelected && !game_data.already_responed"
                    :style="{
                      width: '35%',
                      border: 'none',
                      borderRadius: '60px',
                      cursor: 'pointer',
                      backgroundColor: isSelected ? isButtonColour : '#FFE7E5',
                      // backgroundColor:
                      //   isSelected && isPrevious
                      //     ? isButtonColour
                      //     : isButtonTextColour,
                      color: isButtonTextColour,
                      // color: isSelected ? isButtonTextColour : isButtonColour,
                      fontSize: isLast ? '16px' : '25px',
                      fontWeight: 900
                    }"
                    @click="handleNextQuestion()"
                  >
                    {{ isLast ? "Done" : ">" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Logo -->
    <div
      class="fixed-footer"
      v-if="isLogoVisible"
      style="padding-bottom: 20px;"
    >
      <img
        class="img-fluid"
        style="width: 60px; height: 60px; margin-top: 20px;"
        :src="logoUrl"
        alt="back"
      />
    </div>

    <!-- Share Popup -->
    <div
      v-if="showSharePopup"
      style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;"
    >
      <div
        style="position: relative; width: 100%; max-width: 400px; background: white; border-top-left-radius: 20px; border-top-right-radius: 20px; box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2); text-align: center; padding: 20px 0px;"
      >
        <button
          @click="showSharePopup = false"
          :style="{
            position: 'absolute',
            top: '-55px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'white',
            color: bgTheme,
            border: 'none',
            borderRadius: '50px',
            padding: '11px 16px',
            fontSize: '14px',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
            cursor: 'pointer',
            fontWeight: '700',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px'
          }"
        >
          <div
            :style="{
              width: '16px',
              height: '16px',
              backgroundColor: bgTheme,
              WebkitMaskImage:
                'url(' + asset('chevron-left-red.png') + ')',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              WebkitMaskSize: 'contain',
              maskImage:
                'url(' + asset('chevron-left-red.png') + ')',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              maskSize: 'contain'
            }"
          ></div>
          Go back
        </button>

        <p style="font-weight: bold; margin: 10px 0;">Share via</p>

        <div
          style="display: flex; justify-content: space-evenly; margin-top: 15px;"
        >
          <div @click="getShareMsg(3, 'wa')" style="cursor: pointer;">
            <img
              style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
              src="@/assets/whatsapp.png"
              alt="whatsapp"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px;">WhatsApp</p>
          </div>

          <div @click="getShareMsg(2, 'fb')" style="cursor: pointer;">
            <img
              style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
              src="@/assets/facebook.png"
              alt="facebook"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px;">Facebook</p>
          </div>

          <div @click="getShareMsg(1, 'ig')" style="cursor: pointer;">
            <img
              style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
              src="@/assets/instagram.png"
              alt="instagram"
              class="logo-image"
            />
            <p style="margin: 5px 0; font-size: 12px;">Instagram</p>
          </div>

          <div @click="copyShareLink" style="text-align: center;">
            <div
              :style="{
                width: '40px',
                height: '40px',
                margin: 'auto',
                backgroundColor: bgTheme,
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                marginBottom: '5px'
              }"
            >
              <div
                :style="{
                  width: '20px',
                  height: '20px',
                  backgroundColor: 'white',
                  WebkitMaskImage:
                    'url(' + asset('copy-img1.png') + ')',
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  WebkitMaskSize: 'contain',
                  maskImage: 'url(' + asset('copy-img1.png') + ')',
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  maskSize: 'contain'
                }"
              ></div>
            </div>
            <p style="margin: 0px; font-size: 12px; font-weight: bold;">
              Copy link
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast Notification -->
    <div
      id="copied-toast"
      class="font-bold pos-fixed pos-center-hor pull-down"
      style="width: 100px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none; bottom: 10%;"
    >
      Link Copied
    </div>
  </div>
</template>
<script>
import { asset } from "@/utils/asset";
import { navigateDeeplink } from "@/utils/deeplink";
// import Tasks from '../components/Tasks'
import QuizHeader from "@/components/quiz-header";
import PollHeader from "@/components/poll-header";
import axios from "axios";
import { ref, computed } from "vue";
import { faL } from "@fortawesome/free-solid-svg-icons";
import backgroundImage from "@/assets/back_frame_png.png";
import mainBackgroundImage from "@/assets/back_image_poll.png";
import fallbackImage from "@/assets/team.svg";
import {
  height,
  width
} from "@fortawesome/free-regular-svg-icons/faAddressBook";

import { globals } from "@/mixins/globals";

export default {
  name: "quiz-details-custom",
  mixins: [globals],
  props: {
    date: {
      type: String
    }
  },
  components: {
    QuizHeader,
    PollHeader
  },
  data: () => ({
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    distance: 3600000,
    id: "",
    game_data: "",
    show_detail: true,
    endTime: null,
    valchangeCall: null,
    selectedOptionId: null, // <== track the already selected option
    questionIndex: 0,
    isDisabled: false,
    selectedOptionsMap: {},
    selectedOptionId: null,
    questionIndex: 0,
    selectedOptions: {}, // 🛠️ initialized properly as an empty object
    isSelected: false,
    progress: 20,
    isPrevious: false,
    isLast: false,
    optionRefs: [],
    sliderKnobLeft: 0,
    backgroundImage,
    mainBackgroundImage,
    fallbackImage,
    progressPercentage: 0,
    timer: () => {},
    knobPositionsMap: {}, // { [questionId]: knobLeft }
    progressPercentagesMap: {},
    isLogoVisible: false, // { [questionId]: progressPercentage }
    logoUrl: "",
    isTitle: "",
    isDescription: "",
    isTitleColour: "",
    isDescriptionColour: "",
    isSelectedColour: "",
    isSeekbarColour: "",
    isButtonColour: "",
    isButtonTextColour: "",
    showSharePopup: false,
    userName: "",
    isScoreDataReady: false
  }),
  computed: {
    isScoreDataReady() {
      return (
        this.game_data &&
        this.game_data.user_data &&
        this.game_data.user_data.image_url &&
        this.game_data.additional_data &&
        Array.isArray(this.game_data.additional_data)
      );
    },

    filteredAdditionalData() {
      // Return empty array if game_data is not properly loaded
      if (!this.game_data || typeof this.game_data !== "object") {
        return [];
      }

      const data = Array.isArray(this.game_data.additional_data)
        ? this.game_data.additional_data
        : [];

      const user = this.game_data.user_data || null;

      // If no user data or no additional data, return all additional data
      if (!user || data.length === 0) {
        return data;
      }

      // Filter out the item that matches user_data exactly
      return data.filter(item => {
        if (!item) return true;

        const isMatch =
          parseInt(item.from_score) === parseInt(user.from_score) &&
          parseInt(item.to_score) === parseInt(user.to_score) &&
          String(item.title || "").trim() === String(user.title || "").trim() &&
          String(item.description || "").trim() ===
            String(user.description || "").trim() &&
          String(item.image_url || "").trim() ===
            String(user.image_url || "").trim();
        return !isMatch; // Keep items that DON'T match
      });
    },

    showOnlyOneButton() {
      const showShare =
        this.game_data.enable_share_link &&
        this.game_data.share_link_button_text !== "";
      const showDeeplink =
        this.game_data.enable_deeplink && this.game_data.deeplink_button_text;
      return (showShare && !showDeeplink) || (!showShare && showDeeplink);
    },
    sdkEvent() {
      return this.$store.state.sdkEvent;
    },
    bg_theme() {
      return this.$store.state.bg_theme;
    },

    optionCardWidth() {
      const count = this.game_data.ps_questions[this.questionIndex].options
        .length;
      return Math.floor(100 / Math.min(count));
    },
    optionCardHeight() {
      return this.optionCardWidth * 1.7; // 20% taller than width
    },
    optionCardDivHeight() {
      return this.optionCardHeight * 1.7; // 20% taller than width
    }
  },
  // Complete methods object - replace your entire methods section:

  // Complete methods object - replace your entire methods section:

  methods: {
    copyShareLink() {
      const fullText = this.game_data.share_link_text;

      if (fullText) {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(fullText)
            .then(() => {
              this.showCopiedToast();
              this.showSharePopup = false;
            })
            .catch(err => {
              console.warn("Clipboard API failed:", err);
              this.fallbackCopyText(fullText);
            });
        } else {
          this.fallbackCopyText(fullText);
        }
      } else {
        console.warn("No share text found to copy.");
      }
    },

    fallbackCopyText(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.showCopiedToast();
          this.showSharePopup = false;
        }
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textarea);
    },

    showCopiedToast() {
      const toast = document.getElementById("copied-toast");
      if (toast) {
        toast.style.display = "block";
        setTimeout(() => {
          toast.style.display = "none";
        }, 2000);
      }
    },

    handleShareClick() {
      const text = this.game_data.share_link_text;
      const urlMatch = text.match(/https?:\/\/[^\s]+/);
      if (urlMatch) {
        this.showSharePopup = !this.showSharePopup;
      } else {
        console.warn("No valid share URL found in share_link_text");
      }
    },

    handleDeeplinkClick() {
      navigateDeeplink(this.$router, this.game_data.deeplink_text);
    },

    updateProgress() {
      const total = this.game_data.ps_questions.length;
      this.progress = Math.round(((this.questionIndex + 1) / total) * 100);
    },

    fetchQuizDetails(valChangeCall) {
      var self = this;
      this.pollId = self.id;
      this.valchangeCall = valChangeCall;

      var url =
        self.$store.getters.flyyDomain + "/v1/start_poll_survey/" + self.id;
      var headers = self.$store.getters.headers;

      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            console.log({ data });

            self.game_data = data;

            // ✅ Set isLast to true if only one question exists
            if (data.ps_questions && data.ps_questions.length === 1) {
              self.isLast = true;
            } else {
              self.isLast = false;
            }

            self.selectedOptionsMap = {};

            if (
              data.already_responed &&
              Array.isArray(data.responses) &&
              data.responses.length > 0
            ) {
              data.responses.forEach(response => {
                self.selectedOptionsMap[response.question_id] =
                  response.selected_option;
              });
            }

            console.log("Selected Options Map:", self.selectedOptionsMap);

            const currentQuestionId =
              self.game_data.ps_questions[self.questionIndex].id;
            if (self.selectedOptionsMap.hasOwnProperty(currentQuestionId)) {
              self.selectedOptionId =
                self.selectedOptionsMap[currentQuestionId];
            } else {
              self.selectedOptionId = null;
            }

            this.$store.state.quizDetailsTitle = self.game_data.title;

            var now = new Date();
            var end = new Date(self.game_data.starts_at);

            if (self.game_data.is_live) {
              now = new Date();
              end = new Date(self.game_data.ends_at);
            }
            self.endTime = end;
            self.distance = end - now;

            this.isDisabled = true;

            // ✅ Initialize progress after data is loaded
            this.updateProgress();
          } else {
            console.log("Error fetching the Quiz Details");
          }
        })
        .catch(error => {
          console.error("API Error:", error);
        });
    },

    showDetails() {
      this.show_detail = true;
    },

    showLeaderBoard() {
      this.show_detail = false;
    },

    handleBack() {
      var currentUrl = window.location.pathname;
      if (currentUrl == "/play-quiz") {
        this.$store.state.showExitModal = true;
        return;
      }
      this.$router.go(-1);
    },

    handleNextQuestion() {
      console.log("Nxt BTn...");
      console.log("Is Previous -- ", this.isPrevious);
      console.log(this.game_data.already_responed);

      if (this.isSelected) {
        const currentQuestionId = this.game_data.ps_questions[
          this.questionIndex
        ].id;
        this.knobPositionsMap[currentQuestionId] = this.sliderKnobLeft;
        this.progressPercentagesMap[
          currentQuestionId
        ] = this.progressPercentage;
      }

      this.sliderKnobLeft = 0;
      this.progressPercentage = 0;

      if (!this.isSelected && !this.game_data.already_responed) return;

      console.log("Clicked Next Btn...");
      this.isSelected = false;
      this.isPrevious = true;

      const totalQuestions = this.game_data.ps_questions.length;
      const isLastQuestion = this.questionIndex === totalQuestions - 1;
      console.log("isLastQuestion - ", isLastQuestion);

      if (isLastQuestion) {
        if (!this.game_data.already_responed) {
          const payload = {
            responses: Object.entries(this.selectedOptionsMap).map(
              ([question_id, selected_option]) => ({
                question_id: parseInt(question_id),
                selected_option
              })
            )
          };

          const url =
            this.$store.getters.flyyDomain +
            "/v1/save_poll_survey/" +
            this.pollId;
          const headers = this.$store.getters.headers;

          axios
            .post(url, payload, { headers })
            .then(response => {
              if (response.status === 200) {
                this.game_data.already_responed = true;
                this.game_data.responses = payload.responses;

                if (response.data) {
                  if (response.data.user_data) {
                    this.game_data.user_data = response.data.user_data;
                  }
                  if (response.data.additional_data) {
                    this.game_data.additional_data =
                      response.data.additional_data;
                  }
                  if (response.data.score_screen) {
                    this.game_data.score_screen = response.data.score_screen;
                  }
                  if (response.data.score !== undefined) {
                    this.game_data.score = response.data.score;
                  }
                  if (response.data.updated_options) {
                    response.data.updated_options.forEach((options, idx) => {
                      this.game_data.ps_questions[idx].options = options;
                    });
                  }
                }

                this.$forceUpdate();
              }
            })
            .catch(error => {
              console.error("Error saving poll survey:", error);
            });
        }
      } else {
        this.questionIndex += 1;
        this.updateProgress();
        this.selectedOptionId = null;
        this.isSelected = false;
        this.isLast = false;
      }
    },

    handlePreviousQuestion() {
      this.isLast = false;

      if (this.questionIndex === 0) {
        return;
      }

      if (this.questionIndex === 1) {
        this.isPrevious = false;
      }

      console.log("Clicked Previous Btn...");

      this.questionIndex--;
      this.updateProgress();

      const currentQuestionId = this.game_data.ps_questions[this.questionIndex]
        .id;

      if (this.selectedOptionsMap.hasOwnProperty(currentQuestionId)) {
        this.selectedOptionId = this.selectedOptionsMap[currentQuestionId];
        this.isSelected = true;

        this.$nextTick(() => {
          if (this.knobPositionsMap.hasOwnProperty(currentQuestionId)) {
            this.sliderKnobLeft = this.knobPositionsMap[currentQuestionId];
            this.progressPercentage = this.progressPercentagesMap[
              currentQuestionId
            ];
          } else {
            this.restoreSliderPosition();
          }
        });
      } else {
        this.selectedOptionId = null;
        this.isSelected = false;
        this.sliderKnobLeft = 0;
        this.progressPercentage = 0;
      }
    },

    selectOption(optionId) {
      console.log("clicked Selected option....");
      this.isSelected = true;

      const questions = this.game_data.ps_questions;
      const question =
        questions && questions.length > 0
          ? questions[this.questionIndex]
          : null;

      let selectedOption = null;
      if (question && Array.isArray(question.options)) {
        selectedOption =
          question.options.find(opt => opt.id === optionId) || null;
      }

      if (!question || !selectedOption) {
        console.error("Missing question or selected option");
        return;
      }

      this.selectedOptionId = selectedOption.id;
      this.selectedOptionsMap[question.id] = selectedOption.id;

      console.log("Updated selectedOptionsMap:", this.selectedOptionsMap);

      const totalQuestions = this.game_data.ps_questions.length;
      if (this.questionIndex === totalQuestions - 1) {
        this.isLast = true;
      }

      this.$nextTick(() => {
        const index = question.options.findIndex(opt => opt.id === optionId);
        const wrapper = this.$refs.optionsWrapper;
        const el = this.optionRefs[index];

        if (el && wrapper) {
          const wrapperRect = wrapper.getBoundingClientRect();
          const elRect = el.getBoundingClientRect();
          const centerX = elRect.left + elRect.width / 2;

          this.sliderKnobLeft = centerX - wrapperRect.left - 7;
          this.progressPercentage = centerX - wrapperRect.left - 7 + 4;

          this.knobPositionsMap[question.id] = this.sliderKnobLeft;
          this.progressPercentagesMap[question.id] = this.progressPercentage;

          console.log("KNOB ---", centerX - wrapperRect.left - 7);
        }
      });
    },

    updateSliderKnob(index) {
      const wrapper = this.$refs.optionsWrapper;
      const el = this.optionRefs[index];
      if (el && wrapper) {
        const wrapperRect = wrapper.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        const centerX = elRect.left + elRect.width / 2;
        this.sliderKnobLeft = centerX - wrapperRect.left - 7;
        this.progressPercentage = centerX - wrapperRect.left - 7 + 4;
      }
    },

    restoreSliderPosition() {
      const questions = this.game_data.ps_questions;
      const question = questions[this.questionIndex];

      if (!question) return;

      const selectedId = this.selectedOptionsMap[question.id];
      if (!selectedId) return;

      const index = question.options.findIndex(opt => opt.id === selectedId);
      if (index === -1) return;

      this.$nextTick(() => {
        this.updateSliderKnob(index);

        this.knobPositionsMap[question.id] = this.sliderKnobLeft;
        this.progressPercentagesMap[question.id] = this.progressPercentage;
      });
    }
  },

  mounted() {
    // console.log("sdkEvent on mount:", this.sdkEvent);

    // console.log("Knob Percentage ---->", progressPercentage);

    // console.log(this.$store.state.sdkEvent);

    this.isTitle = this.sdkEvent.isTitle;
    this.isDescription = this.sdkEvent.isDescription;
    this.isTitleColour = this.sdkEvent.isTitleColour;
    this.isDescriptionColour = this.sdkEvent.isDescriptionColour;
    this.isSelectedColour = this.sdkEvent.isSelectedColour;
    this.isSeekbarColour = this.sdkEvent.isSeekbarColour;
    this.isButtonColour = this.sdkEvent.isButtonColour;
    this.isButtonTextColour = this.sdkEvent.isButtonTextColour;
    this.userName = this.sdkEvent.user_name;

    if (this.sdkEvent.logoUrl !== "") {
      this.isLogoVisible = true;
      this.logoUrl = this.sdkEvent.logoUrl;
    } else {
      this.isLogoVisible = false;
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$store.state.quizDetailsId = this.$route.params.id;
    }
    this.id = this.$store.state.quizDetailsId;
    this.$store.state.showQuizHistoryMenu = true;
    this.fetchQuizDetails(false);
  },
  watch: {
    game_data: {
      handler(newVal) {
        if (!newVal) return;

        // Wait for next tick so computed values update
        this.$nextTick(() => {
          this.isScoreDataReady = true;
        });
      },
      deep: true,
      immediate: true
    },
    distance: function(val) {
      if (val <= 0 && !this.valchangeCall) {
        this.fetchQuizDetails(true);
      }
    }
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

.custom-quiz-section {
  background: #ffffff;
  border-radius: 5px;
}
.quiz-details-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.w-full {
  width: 100% !important;
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.detail-header > div {
  width: 50%;
  padding: 10px 1px;
}
.detail-header > span {
  color: var(--bgcolor);
}

.ranking {
  padding: 0.75rem;
  margin: 0.25rem;
}

.rules-text {
  overflow-x: scroll;
  overflow-wrap: break-word;
  scrollbar-width: none;
}
.rules-text span {
  white-space: normal !important;
}

.highlight {
  border-bottom: 1px solid var(--bg-color);
}

/* Mobile devices */
@media (max-width: 480px) {
  .user-card {
    padding: 20px;
    width: 95%;
  }

  .image-box {
    width: 90px !important;
    height: 90px !important;
    top: -45px !important;
  }

  .user-card p {
    font-size: 14px !important;
  }
}

/* Tablets */
@media (max-width: 768px) {
  .user-card {
    width: 92%;
  }

  .image-box {
    width: 100px;
    height: 100px;
    top: -50px;
  }
}

/* Large screens */
@media (min-width: 1024px) {
  .user-card {
    max-width: 600px;
  }
}

.layout-wrapper {
  position: relative;
  /* height: 85vh; */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fixed-footer {
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/* Default for most mobiles */
.card {
  height: 180px;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .selected-options {
    background-color: #ffffff;
    margin-top: 10px;
    border-radius: 8px;
    cursor: pointer;
    padding: 2px 0px;
  }

  .fixed-header {
    margin: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-top: 20px;
    margin-top: 0px;
    position: sticky;
    top: 0;
    z-index: 999;
  }
  .card {
    height: 120px;
    width: 45%;
    border-radius: 20px;
  }
  .card-icon {
    position: absolute;
    top: -30%;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    max-width: 140px;
  }
  .thank-text {
    font-size: 22px;
    margin-bottom: 7px !important;
    font-weight: 600;
    /* line-height: 24px; */
  }
  .thank-des {
    font-size: 14px;
    line-height: 20px;
    margin: 0 !important;
  }
  .deeplink-btn-div {
    width: 265px;
    margin-top: 7px;
    display: flex;
    align-items: center;
    padding: 10px;
    gap: 5px;
  }

  .deeplink-btn {
    border: none;
    padding: 12px;
    border-radius: 18px;
    cursor: pointer;
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .score-main {
    width: 75%;
    border-radius: 20px;
    padding: 30px 20px 15px 20px;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 130px;
    margin-bottom: 2%;
    flex-direction: column;
  }

  .score-heading-div {
    /* margin-top: 30px !important; */
    padding: 10px;
    text-align: center;
  }

  .score-heading {
    font-size: 22px;
    margin-bottom: 10px !important;

    display: -webkit-box;
    -webkit-line-clamp: 2; /* LIMIT to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .score-sub-heading {
    margin-bottom: 7px !important;
    font-size: 12px;
    font-weight: 600;
  }

  .score-logo {
    width: 70px;
    height: 70px;
    position: absolute;
    top: -18%;
  }

  .score-des {
    margin-bottom: 9px !important;
    font-size: 11px;
    color: #33363899;
    line-height: 15px;
  }

  .additional-data-div {
    width: 87%;
    overflow-x: auto;
    display: flex;
    gap: 15px;
    /* padding: 10px 24px 5px 20px; */
    padding-top: 10px;
  }

  .multi-div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-top: 8%;
  }

  .scroll-area {
    flex: 1;
    -webkit-overflow-scrolling: touch;
    height: 90vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 25px;
    overflow-y: auto;
  }

  .moderate-div {
    width: 80px;
    flex: 0 0 auto;
    min-height: 90px; /* Changed from height to min-height */
    border-radius: 10px;
    text-align: center;
    padding: 15px 5px;
    background-color: #ffffff;
    scroll-snap-align: start;
    cursor: pointer;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    display: flex; /* Added for better content alignment */
    flex-direction: column; /* Added for vertical stacking */
    align-items: center; /* Added to center content */
    justify-content: center; /* Added to center content vertically */
  }

  /* .moderate-div {
    width: 80px;
    flex: 0 0 auto;
    height: 90px;
    border-radius: 10px;
    text-align: center;
    padding: 20px 5px;
    background-color: #ffffff;
    scroll-snap-align: start;
    cursor: pointer;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  } */

  .img-moderate {
    width: 60px;
    height: 50px;
    object-fit: contain;
    margin-bottom: 5px !important;
  }

  .moderate-text {
    margin: 0;
    font-size: 9px;
    /* margin-top: 10px; */
    line-height: 13px;
  }

  .score-main-div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 8px;
    width: 100%;
  }

  .next-btn {
    padding: 10px;
  }

  .image-box-rating {
    display: flex;
    flex-wrap: wrap;
    gap: 17px;
    justify-content: space-between;
    padding: 0px 10px;
  }

  .image-pic {
    height: 100px;
  }

  .btn-score-div {
    display: flex;
    align-items: center;
    padding: 10px;
    width: 90%;
    gap: 5px;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .btn-score-div {
    display: flex;
    align-items: center;
    padding: 10px;
    width: 90%;
    gap: 5px;
  }
  .image-pic {
    height: 110px;
  }
  .image-box-rating {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: space-between;
    padding: 0px 15px;
  }
  .next-btn {
    padding: 15px;
  }

  .selected-options {
    background-color: #ffffff;
    margin-top: 10px;
    border-radius: 10px;
    cursor: pointer;
    padding: 7px 0px;
  }

  .fixed-header {
    margin: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-top: 20px;
    margin-top: 0px;
    position: sticky;
    top: 0;
    z-index: 999;
  }
  .card {
    height: 170px;
    width: 55%;
    border-radius: 20px;
  }

  .card-icon {
    position: absolute;
    top: -26%;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    max-width: 140px;
  }

  .thank-text {
    font-size: 24px;
    margin-bottom: 12px !important;
    font-weight: 600;
    /* line-height: 24px; */
  }
  .thank-des {
    font-size: 16px;
    line-height: 24px;
    margin: 0 !important;
  }

  .deeplink-btn-div {
    width: 330px;
    margin-top: 15px;
    display: flex;
    align-items: center;
    padding: 10px;
    gap: 5px;
  }

  .deeplink-btn {
    border: none;
    padding: 17px;
    border-radius: 22px;
    cursor: pointer;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .score-heading-div {
    /* margin-top: 30px !important; */
    padding: 10px;
    text-align: center;
  }

  .score-heading {
    font-size: 22px;
    margin-bottom: 10px !important;

    display: -webkit-box;
    -webkit-line-clamp: 2; /* LIMIT to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .score-sub-heading {
    margin-bottom: 7px !important;
    font-size: 12px;
    font-weight: 600;
    word-break: break-all;
  }

  .score-logo {
    width: 80px;
    height: 80px;
    position: absolute;
    top: -25%;
  }

  .score-des {
    margin-bottom: 9px !important;
    font-size: 11px;
    color: #33363899;
    line-height: 15px;
    word-break: break-all;
  }

  .multi-div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-top: 8%;
  }

  .scroll-area {
    flex: 1;
    -webkit-overflow-scrolling: touch;
    height: 90vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 3%;
  }

  /* .moderate-div {
    width: 100px;
    flex: 0 0 auto;
    min-height: 110px;
    border-radius: 10px;
    text-align: center;
    padding: 20px 5px;
    background-color: #ffffff;
    scroll-snap-align: start;
    cursor: pointer;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  } */

  .moderate-div {
    width: 100px;
    flex: 0 0 auto;
    height: 110px;
    border-radius: 10px;
    text-align: center;
    padding: 20px 5px;
    background-color: #ffffff;
    scroll-snap-align: start;
    cursor: pointer;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  }

  .img-moderate {
    width: 70px;
    height: 60px;
    object-fit: contain;
    margin-bottom: 0px !important;
  }

  .moderate-text {
    margin: 0;
    font-size: 11px;
    margin-top: 10px !important;
    line-height: 13px;
  }

  .score-main-div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 27px;
    width: 100%;
  }

  .additional-data-div {
    width: 93%;
    overflow-x: auto;
    display: flex;
    gap: 15px;
    /* padding: 10px 10px 5px 20px; */
    padding-top: 10px;
  }

  .score-main {
    width: 80%;
    border-radius: 20px;
    padding: 30px 20px 15px 20px;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 130px;
    margin-bottom: 2%;
    flex-direction: column;
  }
}

/* Large mobiles & small tablets */
@media (min-width: 481px) and (max-width: 768px) {
  .card {
    height: 220px;
    width: 60%;
  }
  .card-icon {
    position: absolute;
    top: -24%;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    max-width: 140px;
  }
}

/* Tablets & Desktop */
@media (min-width: 769px) {
  .card {
    height: 260px;
  }
  .card-icon {
    position: absolute;
    top: -24%;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    max-width: 140px;
  }
}
</style>
